import React from 'react'
import { Navigate, Route, Routes } from 'react-router-dom'

import { ScreenContent } from 'components/organisms'
import { HOME, PREVIEW } from 'constants/routesConstants'
import { MqttClientProvider } from 'hooks/useMqttClient'

import GlobalStyle from './styledGlobalStyle'
import * as S from './styled'
import Preview from 'components/pages/Preview'
import AutoReload from 'components/atoms/Autoreload'

const App = () => {
  return (
    <div>
      <AutoReload />
      <S.MasterContainer>
        <GlobalStyle />
        <Routes>
          <Route
            path={HOME}
            element={
              <MqttClientProvider>
                <ScreenContent />
              </MqttClientProvider>
            }
          />
          <Route path={PREVIEW} element={<Preview />} />
          <Route path='*' element={<Navigate to='/' />} />
        </Routes>
      </S.MasterContainer>
    </div>
  )
}

export default App
